import { Component, Input, ElementRef, ViewChild, Renderer2, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'rxjs';
import { __values } from 'tslib';

const INLINE_EDIT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InlineEditComponent),
  multi: true
};

@Component({
  selector: 'inline-edit',
  templateUrl: './inline-edit.component.html',
  providers: [INLINE_EDIT_CONTROL_VALUE_ACCESSOR],
  styleUrls: ['./inline-edit.component.scss']
})

export class InlineEditComponent implements ControlValueAccessor, OnInit {

  @ViewChild('inlineEditControl') inlineEditControl: ElementRef; // input DOM element
  @Input() label: string = '';  // Label value for input element
  @Input() type: string = 'text'; // The type of input element
  @Input() size: number = 5;
  @Input() name: string;
  @Input() required: boolean = false; // Is input requried?
  @Input() disabled: boolean = false; // Is input disabled?
  @Input() editing: boolean = false; // Is Component in edit mode?
  @Input() editable: boolean = false; // Is Component in edit mode?
  @Input() pattern: string = '';
  @Input() id: string = '';
  editSingle: boolean = false;
  private _value: string = ''; // Private variable for input value
  private _originalValue: string = '';
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {
  }
  // Control Value Accessors for ngModel
  get value(): any {
    return this._value;
  }

  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.onChangeCallback(v);
    }
  }

  constructor(element: ElementRef, private _renderer: Renderer2) {
  }

  startEdit() {
    if (this.editable == false) {
      return;
    }

    this._originalValue = this._value;
    this.editSingle = true;

    setTimeout(() => {
      this.inlineEditControl.nativeElement.focus();
    });
  }

  // Required for ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this._value) {
      this._value = value;
    }
  }

  //Set touched on blur
  onBlur() {
    this.editSingle = false;
    this.onTouchedCallback();
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      this.editSingle = false;
    } else if (event.key === "Escape") {
      this._value = this._originalValue;
      this.editSingle = false;
    }
  }

  // Required forControlValueAccessor interface
  public registerOnChange(fn: (_: any) => {}): void {
    this.onChangeCallback = fn;
  }

  // Required forControlValueAccessor interface
  public registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }
}
